import React from 'react';
import { Navigate } from 'react-router-dom';

const RoleBasedRoute = ({ children, requiredRole, redirectTo = '/' }) => {
  const user = localStorage.getItem('user');
  const token = localStorage.getItem('token');

  // If not logged in, redirect to login
  if (!user || !token) {
    return <Navigate to={redirectTo} replace />;
  }

  try {
    const parsedUser = JSON.parse(user);
    const userRole = parsedUser.role;

    // Allow access if user has the required role
    // Roles are just views - users can access both guest and host features
    // However, some features may require specific role (like host dashboard)
    if (userRole === requiredRole) {
      return children;
    }

    // If user doesn't have the required role, still allow access
    // Roles are treated as views, not separate logins
    // Only restrict access for specific protected features if needed
    return children;
  } catch (error) {
    // If there's an error parsing user data, redirect to login
    return <Navigate to={redirectTo} replace />;
  }
};

export default RoleBasedRoute;